export default {
  primary: "primary",
  secondary: "secondary",
  outline: "outline",
  success: "success",
  danger: "danger",
  warning: "warning",
  info: "info",
  light: "light",
  dark: "dark",
  link: "link",
  none: "none",
};
